export const DRAWER_WIDTH = 56; // px : uint

export const LEGAL = "LEGAL";
export const REAL = "REAL";
export const MIXTURE = "MIXTURE";
